import base from './base'
//TODO change file name to base.ts to enable typescript
export default {
    getAllUploaded (productId) {
        return base.get(`${productId}/uploaded`)
    },

    getUploadedContent (uploadedId) {
        return base.get(`uploaded/${uploadedId}`)
    },

    createOrUpdateUploaded (endpointId, data) {
        return base.post(`uploaded/${endpointId}/create_or_update`, data)
    },

    deleteUploaded(endpointId) {
        return base.delete(`uploaded/delete/${endpointId}`)
    }
}